;(function() {
  'use strict'

  Controller.$inject = ["$log", "$scope", "$state", "$stateParams", "$timeout", "glError", "elementService", "surveysService", "messageService"];
  angular
    .module('app.elementCollector')
    .controller('ElementCollector', Controller)

  /* @ngInject */
  function Controller(
    $log,
    $scope,
    $state,
    $stateParams,
    $timeout,
    glError,
    elementService,
    surveysService,
    messageService
  ) {
    var log = $log.create('ElementCollector')

    $scope.data = {}
    $scope.surveyId = $stateParams.sid
    $scope.surveyText = $stateParams.t1 || 'Quick Survey'
    $scope.elementId = $stateParams.elementId
    $scope.messageText = $stateParams.t2 || 'Feedback, Questions or Ideas?'
    $scope.termsUrl = $stateParams.tcs
      ? decodeURIComponent($stateParams.tcs)
      : null
    $scope.themeColor = '#' + ($stateParams.c || 'ff6600')

    $scope.sendMessage = sendMessage
    $scope.buttonStyle = makeButtonStyle()
    $scope.linkStyle = makeLinkStyle()
    $scope.completedSurvey = surveysService.hasCompleted($scope.surveyId)

    $scope.$on('$destroy', onDestroy)

    activate()

    function activate() {
      window.addEventListener('resize', checkHeight)
      checkHeight()

      elementService.get($scope.elementId).then(function(element) {
        $scope.element = element
        $scope.state = 'ready'
      }, onElementError)
    }

    function onElementError() {
      log.error('error fetching element (' + $scope.elementId + ')')
      glError.notFound()
    }

    function sendMessage() {
      messageService.showSendDialog({
        elementId: $scope.element.id,
      })
    }

    function makeButtonStyle() {
      return {
        'background-color': $scope.themeColor,
      }
    }

    function makeLinkStyle() {
      return {
        color: $scope.themeColor,
      }
    }

    function checkHeight() {
      $timeout(function() {
        // Check if window height is small. To un-fix Glow logo from bottom of screen.
        $scope.data.smallHeight = window.innerHeight <= 650
      })
    }

    function onDestroy() {
      window.removeEventListener('resize', checkHeight)
    }
  }
})()
